<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :collection="formCollection"
      :addBtn="!!batchSelectedKeys?.length"
      addText="批量审批"
      :handelAdd="handelBatchApproval"
      :ableSearch="ableSearch"
      :resetWillRequest="true"
      @reset="handelSearch"
      :ableAdd="ableBatch"
    ></search-form>
    <a-modal
      :width="isBatch ? '520px' : '700px'"
      v-model:open="open"
      :title="pageName"
      :footer="null"
      :destroyOnClose="true"
      :maskClosable="false"
      :keyboard="false"
      :class="isBatch ? '' : 'action-form-model'"
    >
      <action
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
        :disabled="true"
        :data="tableData"
        :idField="idField"
        :isBatch="isBatch"
      ></action>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :row-selection="rowSelection"
      :rowKey="record => record[idField]"
      :scroll="{x: 'max-content'}"
      :customRow="handleRow"
      size="small"
    >
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'rowIndex'">
          {{ index + 1 }}
        </template>
        <template v-if="column.key === 'type_id'">
          {{
            codeToText(record.personApplication?.type_id, Enum.carModel.value)
          }}
        </template>
        <template v-if="column.key === 'type'">
          {{ codeToText(record.type, Enum.blackWhiteListType.value) }}
        </template>
        <template v-if="column.key === 'interviewee_depart_id'">
          {{
            codeToText(
              record.personApplication?.interviewee_depart_id,
              Enum.dept.value
            )
          }}
        </template>
        <template v-if="column.key === 'time_range'">
          {{ record.personApplication?.visit_begin_time }} 至
          {{ record.personApplication?.visit_end_time }}
        </template>
        <template v-if="column.key === 'visit_area'">
          {{
            codeToText(
              record.personApplication?.visit_area,
              Enum.areaType.value
            )
          }}
        </template>
        <template v-if="column.key === 'visitor_type'">
          {{
            codeToText(record.personApplication?.visitor_type, Enum.personVisitType.value)
          }}
        </template>
        <template v-if="column.key === 'state'">
          {{ codeToText(record.personApplication?.state, Enum.status.value) }}
        </template>
        <template v-if="column.key === 'create_user_id'">
          {{
            codeToText(
              record.personApplication?.create_user_id,
              Enum.user.value
            )
          }}
        </template>
        <template v-if="column.dataInObject">
          {{
            record[column.dataInObject] &&
            record[column.dataInObject][column.dataIndex]
          }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a-button
              @click="showEditModal(record)"
              :loading="loadingRecord === record"
              v-if="ableCheck && record.personApplication?.state === 1"
            >
              审核
            </a-button>
          </span>
          <span>
            <a-button
              @click="showAmendModal(record)"
              :loading="loadingRecord === record"
              v-if="record.isUpdateAmend"
            >
              编辑来访日期
            </a-button>
          </span>
        </template>
      </template>
    </a-table>

    <a-modal
      v-model:open="amendOpen"
      title="编辑来访日期"
      :footer="null"
      :destroyOnClose="true"
      :keyboard="false"
      class="action-form-model-small"
    >
      <amend
        :v-if="amendOpen"
        @submit="clickOk"
        :editData="editData"
        :data="tableData"
        :idField="idField"
      ></amend>
    </a-modal>
  </div>
</template>
<script>
export default {
  name: 'PersonApplicationApproval',
}
</script>
<script setup>
  import { ref, onMounted, onUnmounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import { getData, checkUpdateField } from '@/api/person_application/person_application_approval'
  import action from './action'
  import amend from './action/amend'
  import searchForm from '@/components/search_form'
  import { codeToText } from '@/utils/format'
  //初始化
  const pageName = '人员预约审核'
  const idField = 'process_task_id' //响应数据的id的字段名
  const store = useStore()
  const Enum = toRefs(store.state.common)
  
  // 定时器引用
  let refreshTimer = null;

  // 获取当前登录角色的申请园区visit_area
  const defaultVisitArea = computed(() => {
    const depart = store.getters['user/depart']
    return depart?.visit_area || ''
  })

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() =>
    !!permissionList.value?.find(item => item.code === 'personAppyApproval:list')
  )
  const ableCheck = computed(() =>
    !!permissionList.value?.find(item => item.code === 'personAppyApproval:check')
  )
  const ableBatch = computed(() =>
    !!permissionList.value?.find(item => item.code === 'personAppyApproval:batch')
  )
  const ableShowDept = computed(() =>
    !!permissionList.value?.find(item => item.code === 'personApplyApproval:ShowDept')
  )

  //1、搜索框
  const formCollection = [
    {
      type: 'input',
      field: 'applicationNumber',
      label: '预约单号',
    },
    {
      type: 'input',
      field: 'visitorName',
      label: '访客姓名',
    },
    {
      type: 'input',
      field: 'visitorCompany',
      label: '来访单位',
    },
    {
      type: 'input',
      field: 'visitorIdcard',
      label: '访客证件号码',
    },
    {
      type: 'input',
      field: 'visitorPhone',
      label: '访客联系号码',
    },
    {
      type: 'select',
      field: 'intervieweeDepartId',
      storeOptions: 'dept',
      label: '被访机构',
      width: '190px',
      'allowClear': true,
      hidden: !ableShowDept.value
    },
    {
      type: 'input',
      field: 'intervieweeName',
      label: '被访人员姓名',
    },
    {
      type: 'input',
      field: 'intervieweePhone',
      label: '被访人联系号码',
    },
    {
      type: 'select',
      field: 'applicationType',
      storeOptions: 'personVisitType',
      label: '申请类型',
      width: '130px',
      'allow-clear': true,
    },
    {
      type: 'select',
      field: 'visitArea',
      storeOptions: 'areaType',
      defaultValue: [1, 2].includes(defaultVisitArea.value) ? defaultVisitArea.value : '',
      label: '访问区域',
      width: '130px',
      'allow-clear': true,
    },
    {
      type: 'dateRange',
      startField: 'beginTime',
      endField: 'endTime',
      // defaultStart: dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
      // defaultEnd: dayjs().add(30, 'day').format('YYYY-MM-DD'),
      label: '时间范围',
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
    const params = {
      ...searchFormRef.value.formState
    }
    store.commit('search/setPerAppliceApproval', params)
  }

  //2、表格
  const columns = [
    {
      title: '序号',
      dataIndex: 'rowIndex',
      key: 'rowIndex',
      align: 'center',
      width: 50,
      fixed: 'left',
    },
    {
      title: '预约单号',
      dataIndex: 'application_number',
      key: 'application_number',
      dataInObject: 'personApplication',
      align: 'left',
    },
    {
      title: '审核状态',
      dataIndex: 'approval_status',
      key: 'approval_status',
      align: 'left',
      width: 130,
    },
    {
      title: '访客姓名',
      dataIndex: 'visitor_name',
      key: 'visitor_name',
      dataInObject: 'personApplication',
      align: 'left',
    },
    {
      title: '访客证件号码',
      key: 'visitor_idcard',
      dataIndex: 'visitor_idcard',
      align: 'left',
      dataInObject: 'personApplication',
    },
    {
      title: '访客联系电话',
      key: 'visitor_phone',
      dataIndex: 'visitor_phone',
      align: 'left',
      dataInObject: 'personApplication',
    },
    /*{
      title: '民族',
      dataIndex: 'visitor_nation',
      key: 'visitor_nation',
      dataInObject: 'personApplication',
      align: 'left',
    },*/
    {
      title: '申请园区',
      // dataIndex: 'visit_area',
      key: 'visit_area',
      dataInObject: 'personApplication',
      align: 'left',
    },
    {
      title: '来访单位',
      dataIndex: 'visitor_company',
      key: 'visitor_company',
      dataInObject: 'personApplication',
      align: 'left',
      width: 180,
    },
    /*{
      title: '来访事由',
      dataIndex: 'visit_content',
      key: 'visit_content',
      align: 'left',
      dataInObject: 'personApplication',
      width: 180,
    },*/
    {
      title: '访客类型',
      // dataIndex: 'visitor_type',
      key: 'visitor_type',
      dataInObject: 'personApplication',
      align: 'left',
    },
    {
      title: '被访人员',
      dataIndex: 'interviewee_name',
      key: 'interviewee_name',
      dataInObject: 'personApplication',
      align: 'left',
    },
    {
      title: '被访人联系电话',
      dataIndex: 'interviewee_phone',
      key: 'interviewee_phone',
      dataInObject: 'personApplication',
      align: 'left',
    },
    {
      title: '被访机构',
      dataIndex: 'interviewee_depart_id',
      key: 'interviewee_depart_id',
      align: 'left',
      width: 180,
    },
    {
      title: '来访时间',
      key: 'time_range',
      align: 'left',
    },
    /*{
      title: '审核状态',
      dataIndex: 'state',
      key: 'state',
      align: 'left',
      width: 130,
    },*/
    {
      title: '提交审核时间',
      dataIndex: 'submit_time',
      key: 'submit_time',
      dataInObject: 'personApplication',
      align: 'left',
      width: 170,
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      fixed: 'right',
      width: '120px',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  function handleTableChange(page) {
    batchSelectedKeys.value = []
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  const handleRow = (record) => {
    return {
      ondblclick: (event) => {
        event.stopPropagation();
        showEditModal(record);
      }
    }
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      for (let i = 0; i < tableData.value.length; i++) {
        checkIsUpdateField({
          person_application_id: tableData.value[i].ref_id,
          process_instance_id: tableData.value[i].process_instance_id
        }).then(res => {
          tableData.value[i].isUpdateAmend = res
        })
      }
      pagination.value.total = data.total
      
      if (data.total > 0 && data.list.length === 0 && pagination.value.current > 1) {
        pagination.value.current -= 1;
        fetch()
      }
    })
  }
  const cachedSearchParams = computed(() => store.state.search.searchPerAppliceApproval)
  // 设置定时刷新
  const setupAutoRefresh = () => {
    // 清除已存在的定时器，避免重复设置
    if (refreshTimer) {
      clearInterval(refreshTimer)
    }
    
    // 设置每分钟刷新一次
    refreshTimer = setInterval(() => {
      // 只有在审核窗口未打开时才执行刷新，避免影响用户操作
      if (!open.value && !amendOpen.value) {
        fetch()
      }
    }, 60000) // 60秒 = 1分钟
  }
  
  onMounted(() => {
    for (const key in cachedSearchParams.value) {
      searchFormRef.value.formState[key] = cachedSearchParams.value[key]
    }
    fetch()
    
    // 启动自动刷新
    setupAutoRefresh()
  })
  
  // 组件卸载时清除定时器，避免内存泄漏
  onUnmounted(() => {
    if (refreshTimer) {
      clearInterval(refreshTimer)
      refreshTimer = null
    }
  })

  const checkIsUpdateField = async (data) => {
    const res = await checkUpdateField(data)
    return res.data
  }
  const amendOpen = ref(false)
  const showAmendModal = async (data) => {
    loadingRecord.value = data
    editData.value = data
    loadingRecord.value = null
    amendOpen.value = true
  }

  //3、审核
  const open = ref(false)
  const isEdit = ref(true)
  const editData = ref(null)
  const showEditModal = (data) => {
    editData.value = data
    isBatch.value = false
    open.value = true
  }

  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
    amendOpen.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //4、批量审批
  const batchSelectedKeys = ref()
  const isBatch = ref(false)
  const rowSelection = computed(() => ({
    onChange: (selectedRowKeys, selectedRows) => {
      batchSelectedKeys.value = selectedRowKeys
    },
    selectedRowKeys: batchSelectedKeys.value,
  }))

  function handelBatchApproval() {
    editData.value = {
      [idField]: batchSelectedKeys.value.toString(),
    }
    isBatch.value = true
    open.value = true
  }
</script>
